<template>
  <div v-if="showBanner" class="maintenance-banner">
    <iwm-callout type="warning" position="inline" :label="maintenanceTitle" duration="0">
      <div class="maintenance-content">
        <p v-if="maintenanceMessage">
          {{ maintenanceMessage }}
        </p>
      </div>
    </iwm-callout>
  </div>
</template>

<script>
import config from '@/config'
import { defineCustomElements } from '@iwm-ds/core/loader'

// Only define custom elements in browser environment (not in Jest/Node)
if (typeof window !== 'undefined' && typeof customElements !== 'undefined') {
  defineCustomElements()
}

export default {
  name: 'MaintenanceBanner',
  computed: {
    showBanner() {
      return config.MAINTENANCE_MODE
    },
    startDate() {
      return config.MAINTENANCE_START_DATE ? new Date(config.MAINTENANCE_START_DATE) : null
    },
    endDate() {
      return config.MAINTENANCE_END_DATE ? new Date(config.MAINTENANCE_END_DATE) : null
    },
    currentDate() {
      return new Date()
    },
    isMaintenanceActive() {
      if (!this.startDate || !this.endDate) return true
      return this.currentDate >= this.startDate && this.currentDate <= this.endDate
    },
    isMaintenanceUpcoming() {
      if (!this.startDate) return false
      return this.currentDate < this.startDate
    },
    maintenanceTitle() {
      return this.$t('maintenance.bannerMessage')
    },
    maintenanceMessage() {
      if (!this.startDate && !this.endDate) {
        return null
      }

      const formatDate = (date) => {
        const options = {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }
        return date.toLocaleString(this.$i18n.locale, options)
      }

      if (this.startDate && this.endDate) {
        if (this.isMaintenanceActive) {
          return this.$t('maintenance.ongoing', {
            endDate: formatDate(this.endDate)
          })
        } else if (this.isMaintenanceUpcoming) {
          return this.$t('maintenance.starting', {
            startDate: formatDate(this.startDate)
          })
        } else {
          return this.$t('maintenance.scheduled', {
            startDate: formatDate(this.startDate),
            endDate: formatDate(this.endDate)
          })
        }
      } else if (this.endDate) {
        return this.$t('maintenance.ongoing', {
          endDate: formatDate(this.endDate)
        })
      } else if (this.startDate) {
        return this.$t('maintenance.starting', {
          startDate: formatDate(this.startDate)
        })
      }

      return null
    }
  }
}
</script>

<style scoped lang="scss">
.maintenance-banner {
  width: 100%;
  flex-shrink: 0;
}

.maintenance-content {
  strong {
    display: block;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    font-size: 0.9em;
  }
}
</style>
